export async function companyExport(payload) {
    return axios.post(route('api.manage.companies.analytics.export.data'), payload)
        .then(({data}) => data);
}